import {getGoogleTrips} from "../../modules"

// TYPES
export const TOGGLE_TRAVELERS_BAR = "TOGGLE_SETTINGS_POPOVER"

// SELECTORS
export const getLayout = (state) => getGoogleTrips(state).layout

// CREATORS
export const toggleTravelersBar = () => ({type: TOGGLE_TRAVELERS_BAR})

// REDUCER
const initialState = {
  travelersBarIsActive: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_TRAVELERS_BAR:
      return {
        ...state,
        travelersBarIsActive: !state.travelersBarIsActive,
      }
    default:
      return state
  }
}
